<button
  class="categoria-card"
  (click)="click.emit($event)"
  >
  @if (isDestacado) {
    <div
      class="categoria-card--destaque"
      >
      Em breve!
    </div>
  }

  <img [src]="image" />
</button>